import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import React, { useEffect, useState } from 'react';

// Importing styles
import './css/bootstrap.css';
import './css/reponsive.css';
import './css/style.css';
// import './css/fontawesome-all.min.css';

// Importing Router
import { BrowserRouter } from "react-router-dom";

// Importing Components 
// import About from './components/About';
import InnerApp from './components/InnerApp';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      const loadTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;

      // Minimum display time for the loader to ensure visibility
      const minimumDisplayTime = 1000; // 1 second

      const remainingTime = Math.max(minimumDisplayTime - loadTime, 0);

      // Hide loader after the remaining time
      setTimeout(() => {
        setIsLoading(false);
      }, remainingTime);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  return (
    <>
      <div>
        {isLoading ? (
          <div style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto'
          }}>
            <DotLottieReact
              src="https://lottie.host/514e6e15-17d8-4bbb-829b-ce95579c4b56/7TI8e9vcDZ.json"
              loop
              autoplay
              style={{
                width: '200px',
                height: '200px',
              }}
            />
          </div>
        ) : (
          <div>
            <BrowserRouter>
              <InnerApp />
            </BrowserRouter>
          </div>
        )}
      </div>
    </>
  );
}

export default App;
